import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-list-index-formatter-renderer',
  template: `
<!--    <select class="form-select form-select-sm"-->
<!--    style="width: 100%; height: 100%; border-radius: 0;">-->
<!--      <option selected>{{currentValue}}</option>-->
<!--    </select>-->

    <div class="d-flex align-items-center justify-content-start">
      <pt-icon *ngIf="editable" class="d-flex" [key]='icon' [size]='12'></pt-icon>
      {{currentValue}}
    </div>
  `,
  styles: [``]
})
export class ListIndexFormatterRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {
  params: any;
  list: Array<string> = [];
  currentValue: string;
  editable = false;
  public icon = IoniconsOutline.edit;

  agInit(params: any): void {
    this.params = params;
    this.editable = params.editable ? true : false;
    if (Array.isArray(this.params.list)) {
      this.list = this.params.list;
    } else {
      this.list = [];
    }
    const value = params.value;
    if (value !== null && value !== undefined && value >= 0 && this.list.length > value) {
      this.currentValue = this.list[this.params.value];
    } else {
      this.currentValue = 'ND';
    }
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }
}
